import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { RegistrationFilter } from '@/types/all-attendees.types';

export const setAllAttendeesRegistrationFilter = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<RegistrationFilter>((state, action) => {
    state.allAttendees.registrationStatusFilter = action.payload;
    state.allAttendees.page = 1;
  });
